module.exports = {
  ALL: 'all',
  PROFILE: 'profile',
  LOCATION: 'location'
}
